import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

export default class ShowMessagePopUp extends Component {  
    constructor(props){
      super(props)
      this.state={
        user:true
      }
    }  
    
    showFalse =() =>{
      this.setState({user:false})
      this.props.falseShowModalPopUp()
    }    
    

    render(){     
      return(
        <Modal show={this.state.user}
        onHide={this.showFalse}
        dialogClassName="modal-90w shadowClass"
        size='md'
        aria-labelledby="contained-modal-title-vcenter"
        centered>          
        <Modal.Body>
        {this.props.message ? this.props.message: 'Something Went Wrong!!!'}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.showFalse}> OK </Button> &nbsp;
          {/* <Button  onClick={this.showFalse}> Cancel </Button> */}
        </Modal.Footer>
        </Modal>) 
    }
    
 
}

  